import {
  type AssignmentStatus,
  ServiceStatus,
  enumAssignmentStatus,
  enumServiceStatus,
} from '@rematter/frontend-lib-api-client';
import { type BadgeProps } from '@rematter/ui-web';

const borderClassMap: Record<string, string> = {
  primary: 'border-l-primary',
  neutral: 'border-l-neutral/40',
  olive: 'border-l-olive',
  purple: 'border-l-purple',
  teal: 'border-l-teal',
  failure: 'border-l-failure',
  success: 'border-l-success',
  warning: 'border-l-warning',
};

export const getStatusBorderClass = (status: ServiceStatus): string => {
  const color = getStatusColor(status);
  return borderClassMap[color ?? 'neutral'] ?? 'border-l-neutral/40';
};

export const getStatusColor = (status: ServiceStatus): BadgeProps['color'] => {
  switch (status) {
    case enumServiceStatus.Draft:
      return 'neutral';
    case enumServiceStatus.Planned:
      return 'olive';
    case enumServiceStatus.InProgress:
      return 'primary';
    case enumServiceStatus.Completed:
      return 'success';
    case enumServiceStatus.Failed:
      return 'failure';
    case enumServiceStatus.Voided:
      return 'neutral';
    default:
      return 'neutral';
  }
};

export const getAssignmentStatusColor = (
  status: AssignmentStatus,
): BadgeProps['color'] => {
  switch (status) {
    case enumAssignmentStatus.Unassigned:
      return 'neutral';
    case enumAssignmentStatus.Offered:
      return 'warning';
    case enumAssignmentStatus.Accepted:
      return 'success';
    case enumAssignmentStatus.Rejected:
      return 'failure';
    case enumAssignmentStatus.Released:
      return 'neutral';
    default:
      return 'neutral';
  }
};
